import { Person } from '@mui/icons-material'
import { AppBar, Avatar, Box, Divider, IconButton, Toolbar } from '@mui/material'
import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { RrdLink } from '../controls'

const Header = () => {

    var isComputerScreen = window.screen.availWidth >= window.screen.availHeight;

    return (isComputerScreen ?
        <AppBar
            position='sticky'
            color='transparent'
        >
            <Toolbar sx={{ minHeight: 50 }}>
                <RrdLink to='/'>
                    <IconButton size='large' disabled>
                        <Avatar
                            variant='square'
                            sx={{
                                backgroundColor: 'transparent',
                                height: 45,
                                width: 45,
                                marginRight: '12px',
                            }}
                        >
                            <img src="/logo.png" alt={'garson'} />
                        </Avatar>
                    </IconButton>
                </RrdLink>
                <Box sx={{ flexGrow: 1 }} />

                    <Divider
                        orientation='vertical'
                        sx={{ 
                            height: 32, 
                            mx: 2,
                            display: { lg: 'flex', md: 'none', xs: 'none' }
                        }} 
                    />
                <Box sx={{ display: 'flex' }}>
                    <Box marginX={2}>
                        <RrdLink to={'/signin'} >
                            <Person fontSize='medium' />
                        </RrdLink>
                    </Box>
                </Box>
                
            </Toolbar>
        </AppBar>
    : '')
}

export default Header